export const usersEn = {
  searchHint: 'You can search user by name, e-mail, position or department',
  headerDepartment: 'Department',
  headerDepartmentRole: 'Department role',
  departmentManager: 'Head of department',
  departmentUser: 'Department participant',
  headerName: 'Name',
  headerEmail: 'E-mail',
  headerPosition: 'Position',
  headerDepartments: 'Departments',
  headerAdmin: 'Is admin',
  tableYes: 'Yes',
  tableNo: 'No',
  downloadXlsxList: 'Download list',
  downloadXlsxPermissions: 'Roles in projects',
  registrationsPopupTitle: 'Verify new user registrations',
  noProjectsSelected: 'Select project',
  acceptBtn: 'Accept',
  rejectBtn: 'Reject',
  waitConfirmAdmin: 'We are waiting for administrator confirmation',
  requestSentToAdmin:
    'Your registration request has been sent to the company administrator. After confirmation you will have access',
  requestSentToAdmin2: (titles: string) =>
    `Your registration request has been sent to the company administrator. After confirmation you will have access to the company ${titles}`,
  buttonTextDialog: 'OK',
  confirmReject: (isMultiple: boolean) =>
    `Are you sure you want to reject the user${
      isMultiple ? "'s" : ''
    } registration? Will ${
      isMultiple ? 'Their' : 'His'
    } data be deleted from the company?`,
  userIsNotFound: 'User is not found',
  invalidPhone: 'Invalid Phone Number',
  phoneIsNotValid: 'Phone number is not valid',
  userHasAuthPhone: 'User already has auth phone',
  lackOfSMSSenderCommand: 'SMS sender command is not configured in config',
  errorWhileReadingLicenseAndMachineKeyFiles:
    'Error while reading license and machine key files',
  tooManyCodeRequests: 'Too many code requests. Contact company administrator',
  lackOfDataToSendSMSWithCode:
    'Phone number or code for sending SMS is not specified',
  errorWhileSendingSMS: 'Error while sending SMS with code',
  smsProviderError: 'SMS provider error',
  licenseIsNotValid: 'License is not valid',
  serviceIsUnavailable: 'Service is unavailable in your region',
  smsCodeIsNotExpired: 'SMS code is not expired',
  incorrectCode: `Incorrect code`,
  twoFactorAuthentication: 'Two-factor authentication',
  twoFactorAuthenticationSuccess: 'Two-factor authentication is connected!',
  twoFactorDescription:
    'Company administrator has enabled two-factor authentication for all employees. Please set up second factor or contact company administrator',
  twoFactorBlocked: 'Too many code requests. Contact company administrator',
  codeSentTo: (phone: string) => `Code is sent to phone number: ${phone}`,
  codeFromSms: 'Code from SMS:',
  sendAgainIn: (seconds: string) => `Send again in ${seconds} seconds`,
  resendCode: 'Resend code',
  phone: 'Phone number',
  userHasToUpdate:
    'To log in to the system, please update the application to the latest version'
}

export const usersRu: typeof usersEn = {
  searchHint: 'Можно искать пользователя по имени, email, должности и отделу',
  headerDepartment: 'Отдел',
  headerDepartmentRole: 'Роль в отделе',
  departmentManager: 'Руководитель отдела',
  departmentUser: 'Сотрудник отдела',
  headerName: 'Имя',
  headerEmail: 'E-mail',
  headerPosition: 'Должность',
  headerDepartments: 'Отделы',
  headerAdmin: 'Администратор',
  tableYes: 'Да',
  tableNo: 'Нет',
  downloadXlsxList: 'Скачать список',
  downloadXlsxPermissions: 'Роли по проектам',
  registrationsPopupTitle: 'Подтвердите регистрацию новых сотрудников',
  noProjectsSelected: 'Выбор проекта',
  acceptBtn: 'Подтвердить',
  rejectBtn: 'Отклонить',
  waitConfirmAdmin: 'Ожидаем подтверждения администратора',
  requestSentToAdmin:
    'Ваш запрос на регистрацию направлен администратору компании. После подтверждения вам откроется доступ',
  requestSentToAdmin2: (titles: string) =>
    `Ваш запрос на регистрацию направлен администратору компании. После подтверждения вам откроется доступ в компанию ${titles}`,
  buttonTextDialog: 'Понятно',
  confirmReject: (isMultiple: boolean) =>
    `Вы действительно хотите отклонить регистрацию пользовател${
      isMultiple ? 'ей' : 'я'
    }? ${isMultiple ? 'Их' : 'Его'} данные будут удалены из компании.`,
  userIsNotFound: 'Пользователь не найден',
  invalidPhone: 'Неверный номер телефона',
  phoneIsNotValid: 'Неверный формат номера телефона',
  userHasAuthPhone: 'Пользователь уже имеет телефон для авторизации',
  errorWhileReadingLicenseAndMachineKeyFiles:
    'Ошибка при чтении файлов лицензии и ключа машины. Обратитесь к администратору',
  lackOfSMSSenderCommand:
    'Команда для отправки СМС сообщений не настроена в конфигурации',
  tooManyCodeRequests:
    'Превышен лимит попыток ввода кода из СМС. Обратитесь к администратору',
  lackOfDataToSendSMSWithCode:
    'Не указан номер телефона или код авторизации для отправки СМС',
  errorWhileSendingSMS: 'Ошибка при отправке СМС c кодом',
  smsProviderError: 'Ошибка СМС провайдера',
  licenseIsNotValid: 'Лицензия недействительна',
  incorrectCode: 'Введен неверный код',
  twoFactorAuthentication: 'Двухфакторная аутентификация',
  twoFactorAuthenticationSuccess: 'Двухфакторная аутентификация подключена!',
  twoFactorDescription:
    'Администратор компании сделал двухфакторную аутентификацию обязательной для всех сотрудников. Пожалуйста, настройте второй фактор или обратитесь к администратору',
  twoFactorBlocked:
    'Превышен лимит попыток ввода кода из СМС на компанию. Обратитесь к администратору',
  codeSentTo: (phone: string) => `Код отправлен на номер телефона: ${phone}`,
  codeFromSms: 'Код из СМС:',
  sendAgainIn: (seconds: string) =>
    `Отправить код повторно возможно через ${seconds}`,
  resendCode: 'Запросить код повторно',
  smsCodeIsNotExpired: 'SMS код уже был отправлен',
  serviceIsUnavailable: 'Сервис недоступен в вашем регионе',
  phone: 'Номер телефона',
  userHasToUpdate: 'Для входа в систему обновите приложение до последней версии'
}
